import { useEffect, useState } from 'react'
import { API } from '../../api'
import { TCategory } from '../../type'

export const useGetCategoryRows = (logic?: string, categoryName?: string) => {
  const [isLoading, setIsLoading] = useState(false)
  const [categoryRows, setCategoryRows] = useState<TCategory | null>(null)

  const getCategoryRows = async () => {
    setIsLoading(true)
    if (categoryName && logic) {
      try {
        const data = await API.CategoryClassification.listCategoryRows(
          encodeURIComponent(logic) as string,
          encodeURIComponent(categoryName) as string,
        )
        setCategoryRows(data)
      } finally {
        setIsLoading(false)
      }
    }
  }

  useEffect(() => {
    if (categoryName && logic) {
      getCategoryRows()
    }
  }, [categoryName, logic])

  return {
    categoryRows,
    isCategoryRowsLoading: isLoading,
    getCategoryRows,
  }
}
